import { reactive, inject } from "vue";

export const userStateSymbol = Symbol("UserState");

export const createStateUser = () => reactive({});

export const useStateUser = () => inject(userStateSymbol);
